module.exports = __webpack_public_path__ + "img/fe7a573.png";